import { render, staticRenderFns } from "./contactListsOverview.vue?vue&type=template&id=d1fbf5e6&"
import script from "./contactListsOverview.vue?vue&type=script&lang=js&"
export * from "./contactListsOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports